import styled from 'styled-components';
var ContentPlaceHolderContainer = styled.div.withConfig({
  displayName: "ContentPlaceholderstyles__ContentPlaceHolderContainer",
  componentId: "sc-638y7c-0"
})(["margin:0 15px 10px;border:1px solid ", ";background:", ";border-radius:3px;overflow:hidden;svg{height:200px;@media (min-width:", "){height:auto;}}"], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var StoreDistanceATTContentPlaceholder = styled.rect.withConfig({
  displayName: "ContentPlaceholderstyles__StoreDistanceATTContentPlaceholder",
  componentId: "sc-638y7c-1"
})(["display:none;@media (min-width:", "){display:block;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
export { ContentPlaceHolderContainer, StoreDistanceATTContentPlaceholder };